import { render, staticRenderFns } from "./Anomalies-User.vue?vue&type=template&id=48181ca4&scoped=true"
import script from "./Anomalies-User.js?vue&type=script&lang=js&external"
export * from "./Anomalies-User.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48181ca4",
  null
  
)

export default component.exports